import { useUser } from '@/context/userContext';
import { MasterAdminPaymentsLimitReachedWidget } from './MasterAdminPaymentsLimitReachedWidget/MasterAdminPaymentsLimitReachedWidget';
import { AdminPaymentsLimitReachedWidget } from './AdminPaymentsLimitReachedWidget/AdminPaymentsLimitReachedWidget';

type PaymentsLimitReachedWidgetType = {
  limitType: 'payment' | 'deposit';
};

export const PaymentsLimitReachedWidget = ({ limitType }: PaymentsLimitReachedWidgetType) => {
  const { isMasterAdminRole, isOrgAdminRole } = useUser();

  return (
    <>
      {isMasterAdminRole && <MasterAdminPaymentsLimitReachedWidget limitType={limitType} />}
      {isOrgAdminRole && <AdminPaymentsLimitReachedWidget limitType={limitType} />}
    </>
  );
};
